var map = {
	"./ship-cargo-critical.png": 83906,
	"./ship-cargo-protection.png": 33324,
	"./ship-cargo.png": 68830,
	"./ship-fishing-critical.png": 34672,
	"./ship-fishing-protection.png": 89986,
	"./ship-fishing.png": 44732,
	"./ship-high-speed-craft-critical.png": 30757,
	"./ship-high-speed-craft-protection.png": 23711,
	"./ship-high-speed-craft.png": 2919,
	"./ship-navigation-critical.png": 72966,
	"./ship-navigation-protection.png": 46304,
	"./ship-navigation.png": 62178,
	"./ship-passenger-critical.png": 50734,
	"./ship-passenger-protection.png": 41944,
	"./ship-passenger.png": 22490,
	"./ship-pleasure-critical.png": 55131,
	"./ship-pleasure-protection.png": 46213,
	"./ship-pleasure.png": 24389,
	"./ship-tanker-critical.png": 63667,
	"./ship-tanker-protection.png": 28333,
	"./ship-tanker.png": 75213,
	"./ship-tug-special-critical.png": 26200,
	"./ship-tug-special-protection.png": 93978,
	"./ship-tug-special.png": 97108,
	"./ship-unspecified-critical.png": 93389,
	"./ship-unspecified-protection.png": 94167,
	"./ship-unspecified.png": 31455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69513;